import React from 'react';
import { motion } from 'framer-motion';

const GandalfLogo = ({ size = 'large', className = '' }) => {
  const isLarge = size === 'large';
  const containerSize = isLarge ? 'w-10 h-10' : 'w-5 h-5';
  const svgSize = isLarge ? 'w-10 h-10' : 'w-5 h-5';

  return (
    <div className={`relative ${containerSize} flex items-center justify-center ${className}`}>
      {/* Main wizard hat - same design as sidebar but scalable */}
      <motion.svg 
        className={`${svgSize} text-current relative z-10`}
        fill="currentColor" 
        viewBox="0 0 24 24"
        animate={{ 
          y: [0, isLarge ? -1 : -0.5, 0],
          rotate: [0, 0.5, -0.5, 0]
        }}
        transition={{ 
          duration: 5, 
          repeat: Infinity, 
          ease: "easeInOut"
        }}
      >
        {/* Wizard Hat */}
        <path d="M12 2L6 20h12L12 2z" />
        {/* Hat Brim */}
        <ellipse cx="12" cy="20" rx="8" ry="2" />
        
        {/* Twinkling Stars */}
        <motion.circle 
          cx="10" 
          cy="12" 
          r={isLarge ? "0.6" : "0.4"}
          fill="currentColor"
          animate={{ opacity: [0.4, 1, 0.4] }}
          transition={{ duration: 2.5, repeat: Infinity, delay: 0 }}
        />
        <motion.circle 
          cx="14" 
          cy="8" 
          r={isLarge ? "0.6" : "0.4"}
          fill="currentColor"
          animate={{ opacity: [0.4, 1, 0.4] }}
          transition={{ duration: 2.5, repeat: Infinity, delay: 0.8 }}
        />
        <motion.circle 
          cx="11" 
          cy="6" 
          r={isLarge ? "0.6" : "0.4"}
          fill="currentColor"
          animate={{ opacity: [0.4, 1, 0.4] }}
          transition={{ duration: 2.5, repeat: Infinity, delay: 1.6 }}
        />
      </motion.svg>
      
      {/* Subtle magical sparkle - scaled for size */}
      <motion.div
        className={`absolute ${isLarge ? '-top-1 -right-1 w-1.5 h-1.5' : '-top-0.5 -right-0.5 w-1 h-1'} bg-current rounded-full opacity-60`}
        animate={{ 
          scale: [0.5, 1, 0.5],
          opacity: [0.3, 0.8, 0.3]
        }}
        transition={{ 
          duration: 3, 
          repeat: Infinity, 
          ease: "easeInOut" 
        }}
      />
    </div>
  );
};

export default GandalfLogo; 